<div class="sidenav fx-column" *ngIf="mode !== 'hidden'">
    <ng-container *ngFor="let section of navigationButtonSections; let i = index">
        <ng-container *ngIf="section.buttons.length">
            <!-- section -->
            <div class="section-name" [class.active]="section.active" *ngIf="section.sectionName">
                {{ section.sectionName }}
            </div>

            <!-- Navigation buttons -->
            <ng-container *ngFor="let btn of section.buttons">
                <a
                    [routerLinkActive]="'active'"
                    mat-icon-button
                    [routerLink]="[btn.routerLink]"
                    [matTooltip]="btn.name | translate"
                    matTooltipPosition="right"
                >
                    <mat-icon [svgIcon]="btn.svgIcon"></mat-icon>
                </a>
            </ng-container>
        </ng-container>
        <span *ngIf="i == 0 && isChargEye && !(isMyKempower$ | async)">
            <span *ngIf="skipDialog">
                <a
                    target="_self"
                    [href]="betaLink"
                    class="sidenav-CeBetaLink"
                    [matTooltip]="'Go to ChargEye beta'"
                    matTooltipPosition="right"
                    rel="noopener"
                >
                    <div>
                        <mat-icon svgIcon="k-bolt-link"></mat-icon>
                    </div>
                    ChargEye beta
                </a>
            </span>
            <span *ngIf="!skipDialog">
                <button
                    *ngIf="i == 0 && isChargEye && !(isMyKempower$ | async)"
                    class="sidenav-CeBetaLink"
                    (click)="navigateToBeta()"
                    [matTooltip]="'Go to ChargEye beta'"
                    matTooltipPosition="right"
                >
                    <div>
                        <mat-icon svgIcon="k-bolt-link"></mat-icon>
                    </div>
                    ChargEye beta
                </button>
            </span>
        </span>
    </ng-container>
</div>
